(function() { window.GUID_fdc439b2_3cb8_45e4_a817_41c189700e94 = { getGuid: function() { return "fdc439b2-3cb8-45e4-a817-41c189700e94"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let SnackbarAlignment;
        (function (SnackbarAlignment) {
            SnackbarAlignment[SnackbarAlignment["TopLeft"] = 0] = "TopLeft";
            SnackbarAlignment[SnackbarAlignment["TopCenter"] = 1] = "TopCenter";
            SnackbarAlignment[SnackbarAlignment["TopRight"] = 2] = "TopRight";
            SnackbarAlignment[SnackbarAlignment["MiddleLeft"] = 3] = "MiddleLeft";
            SnackbarAlignment[SnackbarAlignment["MiddleCenter"] = 4] = "MiddleCenter";
            SnackbarAlignment[SnackbarAlignment["MiddleRight"] = 5] = "MiddleRight";
            SnackbarAlignment[SnackbarAlignment["BottomLeft"] = 6] = "BottomLeft";
            SnackbarAlignment[SnackbarAlignment["BottomCenter"] = 7] = "BottomCenter";
            SnackbarAlignment[SnackbarAlignment["BottomRight"] = 8] = "BottomRight";
        })(SnackbarAlignment = Enumeration.SnackbarAlignment || (Enumeration.SnackbarAlignment = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=SnackbarAlignment.pre.js.map
